import { Record, List } from 'immutable';

const defaultValues = {
    customerId: null,
    address: null,
    accountId: null,
    opcoId: null,
    name: null,
    accountType: null,
    territory: null,
    status: null,
    isActive: false,
    street: null,
    city: null,
    state: null,
    postalCode: null,
    isSelected: false,
};

export default class AssignedAccount extends Record(defaultValues, AssignedAccount) {
    constructor(values) {
        super({
            ...values,
        });
    }

    static filterAccountsByCustomerNum(accounts, keywords) {
        let keywordsUpper = keywords.toUpperCase();
        return accounts.filter((account) => {
            return account.get('name') && account.get('name').toUpperCase().includes(keywordsUpper)
                || account.get('accountId') && account.get('accountId').toUpperCase().includes(keywordsUpper)
        });
    }

    static filterAccountByOpcoIdNum(accounts, opcoId) {
        return accounts.filter((account) => {
            return account.get('opcoId') == opcoId;
        });
    }

    static getDefaultOpcoValue(accounts) {
        return accounts.first();
    }

    /**
     * return first match of the given account list on accountId
     * @param {List} accounts AssignedAccount record list
     * @param {String} accountId exact accountId
     * @returns first match of accounts
     */
    static findByAccountId(accounts, accountId) {
        return accounts && accounts.size > 0 ?
            accounts.find(account => account && account.get('accountId') === accountId) :
            new AssignedAccount();
    }
}

export const AssignedAccounts = data => {
    let accounts = new List();
    if (!data) {
        return accounts;
    }

    for (const record of data) {
        accounts = accounts.push(new AssignedAccount(record));
    }

    return accounts;
}
